import { render, staticRenderFns } from "./ManualOrdersForm.vue?vue&type=template&id=4ce0b250&scoped=true"
import script from "./ManualOrdersForm.vue?vue&type=script&lang=js"
export * from "./ManualOrdersForm.vue?vue&type=script&lang=js"
import style0 from "./ManualOrdersForm.vue?vue&type=style&index=0&id=4ce0b250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce0b250",
  null
  
)

export default component.exports